"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setVisibleAdyenPaymentMethods = exports.setTheme = exports.setTermsUrl = exports.setRefreshToken = exports.setPublisher = exports.setOfferSelectionUrl = exports.setOffer = exports.setMyAccountUrl = exports.setMyAccountPayPalUrls = exports.setLanguage = exports.setJWT = exports.setHidePayPal = exports.setHiddenPaymentMethods = exports.setEnvironment = exports.setEnable3DSRedirectFlow = exports.setData = exports.setCheckoutPayPalUrls = exports.removeData = exports.getTheme = exports.getData = exports.default = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _store = _interopRequireDefault(require("../redux/store"));
var _appConfig = require("../redux/appConfig");
var _publisherConfigSlice = require("../redux/publisherConfigSlice");
const isLocalStorageAvailable = () => {
  try {
    localStorage.setItem('CLEENG_LS', 'yes');
    if (localStorage.getItem('CLEENG_LS') === 'yes') {
      localStorage.removeItem('CLEENG_LS');
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
};
const getData = name => {
  const result = isLocalStorageAvailable() ? localStorage.getItem(name) : _store.default.getState().appConfig[name];
  if (!result && name === 'CLEENG_AUTH_TOKEN') {
    // eslint-disable-next-line no-console
    console.error("Unable to get CLEENG_AUTH_TOKEN from local storage or redux store");
    return null;
  }
  return result;
};
exports.getData = getData;
const setData = (name, value) => isLocalStorageAvailable() ? localStorage.setItem(name, value) : _store.default.dispatch((0, _appConfig.setData)({
  name,
  value
}));
exports.setData = setData;
const removeData = name => isLocalStorageAvailable() ? localStorage.removeItem(name) : _store.default.dispatch((0, _appConfig.removeData)({
  name
}));
exports.removeData = removeData;
const setJWT = jwt => {
  if (jwt) {
    setData('CLEENG_AUTH_TOKEN', jwt);
    return true;
  }
  return false;
};
exports.setJWT = setJWT;
const setRefreshToken = refreshToken => {
  if (refreshToken) {
    setData('CLEENG_REFRESH_TOKEN', refreshToken);
    return true;
  }
  return false;
};
exports.setRefreshToken = setRefreshToken;
const setPublisher = publisherId => {
  if (publisherId) {
    setData('CLEENG_PUBLISHER_ID', publisherId);
    _store.default.dispatch((0, _publisherConfigSlice.init)({
      publisherId
    }));
    return true;
  }
  return false;
};
exports.setPublisher = setPublisher;
const setOffer = offerId => {
  if (offerId) {
    setData('CLEENG_OFFER_ID', offerId);
    return true;
  }
  return false;
};
exports.setOffer = setOffer;
const setEnvironment = env => {
  if (env) {
    setData('CLEENG_ENVIRONMENT', env);
    return true;
  }
  return false;
};
exports.setEnvironment = setEnvironment;
const setCheckoutPayPalUrls = urls => {
  if (urls) {
    const {
      successUrl,
      cancelUrl,
      errorUrl
    } = urls;
    setData('CLEENG_CHECKOUT_PP_SUCCESS', successUrl);
    setData('CLEENG_CHECKOUT_PP_CANCEL', cancelUrl);
    setData('CLEENG_CHECKOUT_PP_ERROR', errorUrl);
    return true;
  }
  return false;
};
exports.setCheckoutPayPalUrls = setCheckoutPayPalUrls;
const setMyAccountPayPalUrls = urls => {
  if (urls) {
    const {
      successUrl,
      cancelUrl,
      errorUrl
    } = urls;
    setData('CLEENG_MYACCOUNT_PP_SUCCESS', successUrl);
    setData('CLEENG_MYACCOUNT_PP_CANCEL', cancelUrl);
    setData('CLEENG_MYACCOUNT_PP_ERROR', errorUrl);
    return true;
  }
  return false;
};
exports.setMyAccountPayPalUrls = setMyAccountPayPalUrls;
const setMyAccountUrl = url => {
  if (url) {
    setData('CLEENG_MY_ACCOUNT_URL', url);
    return true;
  }
  return false;
};
exports.setMyAccountUrl = setMyAccountUrl;
const setOfferSelectionUrl = url => {
  if (url) {
    setData('CLEENG_OFFER_SELECTION_URL', url);
    return true;
  }
  return false;
};
exports.setOfferSelectionUrl = setOfferSelectionUrl;
const setTermsUrl = termsUrl => {
  if (termsUrl) {
    setData('CLEENG_TERMS_URL', termsUrl);
    _store.default.dispatch((0, _publisherConfigSlice.init)({
      termsUrl
    }));
    return true;
  }
  return false;
};
exports.setTermsUrl = setTermsUrl;
const setTheme = theme => {
  const themeString = JSON.stringify(theme);
  if (theme) {
    setData('CLEENG_THEME', themeString);
    return true;
  }
  return false;
};
exports.setTheme = setTheme;
const getTheme = () => {
  const theme = getData('CLEENG_THEME');
  if (theme) {
    return JSON.parse(theme);
  }
  return false;
};
exports.getTheme = getTheme;
const setVisibleAdyenPaymentMethods = visiblePaymentMethods => {
  _store.default.dispatch((0, _publisherConfigSlice.init)({
    visiblePaymentMethods
  }));
  return true;
};
exports.setVisibleAdyenPaymentMethods = setVisibleAdyenPaymentMethods;
const setHidePayPal = () => {
  _store.default.dispatch((0, _publisherConfigSlice.init)({
    isPayPalHidden: true
  }));
  return true;
};
exports.setHidePayPal = setHidePayPal;
const setHiddenPaymentMethods = hiddenPaymentMethods => {
  _store.default.dispatch((0, _publisherConfigSlice.updateHiddenPaymentMethods)(hiddenPaymentMethods));
  return true;
};
exports.setHiddenPaymentMethods = setHiddenPaymentMethods;
const setEnable3DSRedirectFlow = () => {
  _store.default.dispatch((0, _publisherConfigSlice.init)({
    enable3DSRedirectFlow: true
  }));
  return true;
};
exports.setEnable3DSRedirectFlow = setEnable3DSRedirectFlow;
const setLanguage = async language => {
  const BASE_URL = window.location.origin;
  if (!_i18next.default.hasResourceBundle(language, 'translations')) {
    const data = await fetch("".concat(BASE_URL, "/cleeng-translations/").concat(language, "/translations.json")).then(response => {
      return response.json();
    })
    // Do not remove catch below
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    .catch(() => {});
    _i18next.default.addResourceBundle(language, 'translations', data, true, true);
  }
  _i18next.default.changeLanguage(language);
  return true;
};
exports.setLanguage = setLanguage;
var _default = exports.default = {
  setPublisher,
  setOffer,
  setEnvironment,
  setTheme,
  setCheckoutPayPalUrls,
  setMyAccountPayPalUrls,
  setMyAccountUrl,
  setOfferSelectionUrl,
  setJWT,
  setRefreshToken,
  setTermsUrl,
  setHidePayPal,
  setVisibleAdyenPaymentMethods,
  setHiddenPaymentMethods,
  setLanguage,
  setEnable3DSRedirectFlow
};